// Centralized pin level / membership badge config.
// Each tier renders as a CircleBadge with its own bg/text colors.
//
// The membership letters C and P come from the Figma and are what the business
// uses, but the words behind them are the SQL group names in Common.Groups
// (joined via Store.VisibilityGroups on VisibilityGroupTypeId 1):
//   P -> GroupId 1, "Active Premier Members"
//   C -> GroupId 3, "Complimentary Members"
// These previously read "Prospect" and "Customer", which are CRM contact types
// and are not membership groups at all. Keep the letters, keep the SQL wording.
//
// The fills below are sampled from the scope doc's permission row, which draws
// the same six badges identically on every screen that shows them. White is not
// one of them -- it is reserved for a permission that is switched off.
export const PIN_LEVEL_BADGES = {
  IBO: { label: "IBO", title: "IBO", bgColor: "#d8d8d8", textColor: "#000000" },
  PLA: { label: "PLA", title: "Platinum", bgColor: "#495059", textColor: "#ffffff" },
  EME: { label: "EME", title: "Emerald", bgColor: "#415264", textColor: "#ffffff" },
  EM: { label: "EME", title: "Emerald", bgColor: "#415264", textColor: "#ffffff" },
  DIA: { label: "DIA", title: "Diamond", bgColor: "#90b6ba", textColor: "#000000" },
};

export const MEMBERSHIP_BADGES = {
  C: {
    label: "C",
    title: "Complimentary Members",
    bgColor: "#d8d8d8",
    textColor: "#000000",
  },
  P: {
    label: "P",
    title: "Active Premier Members",
    bgColor: "#90b6ba",
    textColor: "#000000",
  },
  ...PIN_LEVEL_BADGES,
};
